import { ParameterAddDimensionPlaceholderRowCell } from './ParameterAddDimensionPlaceholderRowCell'
import { ParameterDimensionRowCell } from './ParameterDimensionRowCell'
import {
  isAddParameterDefinitionDimensionPlaceholder,
  type ParameterDimensionDefinitionRowData,
} from './types'

type Props = {
  data: ParameterDimensionDefinitionRowData
  column: number
  row?: number
}

export const ParameterDimensionRowCellSelector = ({ data, ...other }: Props) =>
  isAddParameterDefinitionDimensionPlaceholder(data) ? (
    <ParameterAddDimensionPlaceholderRowCell {...other} />
  ) : (
    <ParameterDimensionRowCell data={data} {...other} />
  )
